import React, { useContext, useEffect, useState } from 'react';
import {
  number as numberType,
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { IntroOffer } from './subcomponents/intro-offer/intro-offer.component';
import { PaymentEstimator } from './subcomponents/payment-estimator/payment-estimator.component';
import { OffersForYou } from './subcomponents/offers-for-you/offers-for-you.component';
import { loadEstimatorScript } from './utils';

export const ConsumerCardMessaging = (props) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  const { itemId, bundlePrice } = props;
  const { paymentEstimatorVersion = 'v1.0.33' } = useLayoutGroupProps({ props });
  // Should we add `useStore()`, even though the experience should pass it as a defaultVariable???
  const { storeId, storeZip } = useStore();
  const { data, error, loading } = bundlePrice ? {} : useDataModel('product', { variables: { itemId } });

  const [paymentEstimatorLoaded, setPaymentEstimatorLoaded] = useState(false);

  useEffect(() => {
    loadEstimatorScript(paymentEstimatorVersion, () => setPaymentEstimatorLoaded(true), channel === 'mobile');
  }, []);

  if (loading || !paymentEstimatorLoaded) {
    return (
      <LoadingPlaceholder
        type="text"
        ready={false}
        color="#E0E0E0"
        rows={2}
        showLoadingAnimation
      >
        Loading...
      </LoadingPlaceholder>
    );
  }

  if (bundlePrice) {
    return (
      <OffersForYou
        price={`${bundlePrice}`}
        isMobile={channel === 'mobile'}
      />
    );
  }

  if (error && !data && !loading) {
    return null;
  }

  const pricing = data?.product?.pricing;
  const isAppliance = data?.product?.identifiers?.productType === 'MAJOR_APPLIANCE';
  if (!pricing) return null;

  const { value } = pricing;
  return value >= 299.00
    ? (
      <PaymentEstimator
        price={`${value}`}
        isMobile={channel === 'mobile'}
        isAppliance={isAppliance}
      />
    )
    : <IntroOffer mobile={channel === 'mobile'} />;
};

ConsumerCardMessaging.displayName = 'ConsumerCardMessaging';

ConsumerCardMessaging.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    pricing: params({ storeId: stringType() }).shape({
      value: numberType()
    }),
    identifiers: shapeType({
      productType: stringType()
    })
  })
};

const checkRequiredProps = (props) => {
  if (!props.itemId && !props.bundlePrice) {
    return new Error('The \'itemId\' or \'bundlePrice\' is required by the consumer-card-messaging component.');
  }
  return null;
};

ConsumerCardMessaging.propTypes = {
  itemId: checkRequiredProps,
  bundlePrice: checkRequiredProps,
};

ConsumerCardMessaging.defaultProps = {
  itemId: null,
  bundlePrice: null,
};
